import React from 'react'
import SidebarStrain from './StrainRepository/StrainDashboard/SidebarStrain'
import {
    Avatar, Box, Button, Grid, Paper, Table, TableCell, TableContainer, TableBody, TableHead,
    TableRow, TextField, Typography, Card, CardContent, CardHeader, Tooltip, Modal, Divider, Backdrop, CircularProgress
} from '@mui/material';


export default function Footer() {

    const drawerWidth = 260;

    return (
        <>


            {/* <footer style={{ display: 'grid', width: '100%', backgroundColor: '#2c88da', padding: '10px' }} >
                
                <div className='container' style={{ paddingTop: '5px'}}>
                    <h6 className="rubik-font" style={{
                        fontWeight: 500, fontFamily: 'Rubik, sans-serif',
                        color: 'white', textAlign: 'center'
                    }}>Designed and Developed by CDAC, Kolkata</h6>
                </div>

                
            </footer> */}


        </>
    )
}
